import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as accountModal from "accountModal";
import * as modalDialog from "modalDialog";
import * as mustcache from "mustcache";

/* arguments
 * ---------
 *
 * - model: SelectionModel
 * - actions: list of possible actions {title: String, id: String}
 */
const AddToShelfView = Backbone.View.extend({
  initialize: function (options) {
    this.options = options || {};
    this.models = options.models;
    this.listenTo(this.model, "change:count", () => {
      this.updateState();
    });
    this.listenTo(this.models.shelves, "change:books add remove", () => {
      this.render({ dropdownOnly: true });
    });
    this.render();
  },
  render: function (renderOptions, callback) {
    const data: { [key: string]: any } = {
      shelves: this.models.shelves
        .filter((shelf) => shelf.id !== "unshelved")
        .map((shelf) => ({
          _id: shelf.id,
          name: shelf.get("name"),
          bookCount: shelf.get("bookCount") || shelf.get("books").length,
          state: this.getShelfState(shelf),
        })),
    };
    data.shelvesExist = data.shelves.length > 0;
    mustcache.render("addToShelfView", data, (html) => {
      if (renderOptions && renderOptions.dropdownOnly) {
        this.$(".dropdownButtonList")
          .empty()
          .append($(html).find(".dropdownButtonList").children());
      } else {
        this.$el.html(html);
      }

      this.$('[data-state="checked"]').prop("checked", true);
      this.$('[data-state="unchecked"]').prop("checked", false);
      this.$('[data-state="indeterminate"]')
        .prop("checked", false)
        .prop("indeterminate", true);

      this.$(".dropdownButton").prop("disabled", this.model.get("count") === 0);

      if (this.hasStateChangedSinceDropdown()) {
        this.$(".dropdownButtonList").addClass("changed");
      } else {
        this.$(".dropdownButtonList").removeClass("changed");
      }

      // can't use delegate events for this since it goes into a modal
      this.$('input[type="checkbox"][data-shelfID]')
        .off()
        .change(this.changeShelfCheckbox.bind(this));
      this.$(".undoChanges").off().click(this.undoChanges.bind(this));
      this.$(".addNewShelf").off().click(this.startAddNewShelfMode.bind(this));
      this.$(".createNewShelfButton")
        .off()
        .click(this.createNewShelf.bind(this));
      this.$(".closeDialogButton").off().click(modalDialog.cancel);

      if (callback) {
        callback();
      }
    });
  },
  startAddNewShelfMode: function () {
    this.$(".dropdownButtonList").addClass("addNewShelfMode");
    this.$(".newShelfInput").focus();
  },
  createNewShelf: function (event) {
    event.preventDefault();
    event.stopPropagation();

    this.$(".dropdownButtonList").removeClass("addNewShelfMode");

    const name = this.$(".newShelfInput").val();

    this.models.shelves.create(
      {
        name: name,
        language: this.models.user.get("currentLearningLanguage"),
        books: [],
      },
      {
        wait: true,
      }
    );
  },
  hasStateChangedSinceDropdown: function () {
    return (
      this.shelfBooksAtDropdown &&
      !this.models.shelves.every((shelf) => {
        const booksAtDropdown = this.shelfBooksAtDropdown[shelf.id];
        return (
          booksAtDropdown &&
          booksAtDropdown.length === shelf.get("books").length
        );
      })
    );
  },
  changeShelfCheckbox: function (event) {
    const $target = $(event.target);
    const shelf = this.models.shelves.get($target.attr("data-shelfID"));
    let books = _.pluck(shelf.get("books"), "bookID");

    if ($target.is(":checked")) {
      books = _.union(books, this.model.get("itemIDs"));
    } else {
      books = _.difference(books, this.model.get("itemIDs"));
    }

    shelf.save(
      "books",
      _.map(books, (bookID) => ({
        bookID,
      })),
      { patch: true }
    );
  },
  updateState: function () {
    if (
      _.any(
        this.model.getSelectedItems(),
        (book) => book.get("userBook") && book.get("userBook").tags.length > 0
      )
    ) {
      this.$el.find(".dropdownButton").prop("disabled", false);
    } else {
      this.$el.find(".dropdownButton").prop("disabled", true);
    }
  },
  getShelfState: function (shelf) {
    // checked      - all selected texts are within this shelf
    // unchecked    - none of the selected texts are within this shelf
    // indeterminate - some, but not all selected texts are within this shelf

    let hasBookInShelf = false;

    let hasBookNotInShelf = false;

    // WARNING: only designed to work on itemIDs - not on wholePage / wholeCollection selections
    const shelfBookIndex = shelf.getBookIndex();

    _.each(this.model.get("itemIDs"), (bookID) => {
      if (shelfBookIndex[bookID]) {
        hasBookInShelf = true;
      } else {
        hasBookNotInShelf = true;
      }
    });

    if (hasBookInShelf && !hasBookNotInShelf) {
      return "checked";
    } else if (hasBookInShelf && hasBookNotInShelf) {
      return "indeterminate";
    } else {
      return "unchecked";
    }
  },
  events: {
    "click .dropdownButton": "clickDropdown",
  },
  clickDropdown: function () {
    if (
      this.models.user.get("subscriptionPlan") !== "standard" &&
      this.models.user.get("subscriptionPlan") !== "plus" &&
      this.models.user.get("subscriptionPlan") !== "freeForever"
    ) {
      accountModal.show({
        model: this.models.user,
        title: "shelves",
        messageHtml: "<h2>Go premium to create shelves...</h2>",
        showTitle: false,
      });
      return;
    }
    this.shelfBooksAtDropdown = {};

    this.models.shelves.each((shelf) => {
      this.shelfBooksAtDropdown[shelf.id] = _.clone(shelf.get("books"));
    });

    this.render({}, () => {
      modalDialog.show(this.$el.find(".dropdownButtonList"), {
        center: false,
        closeButton: false,
        cancelCallback: () => {
          this.options.finishEditingCallback();
        },
      });
    });
  },
  undoChanges: function () {
    const shelvesToDestroy = [];

    this.models.shelves.each((shelf) => {
      if (!this.shelfBooksAtDropdown[shelf.id]) {
        console.error(
          "TODO: remove shelf that didn't exist at dropdown: ",
          shelf.id
        );
        shelvesToDestroy.push(shelf);
        return;
      }
      if (
        shelf.get("books").length !== this.shelfBooksAtDropdown[shelf.id].length
      ) {
        shelf.save(
          { books: this.shelfBooksAtDropdown[shelf.id] },
          { patch: true }
        );
      }
    });

    _.each(shelvesToDestroy, (shelf) => {
      shelf.destroy();
    });
  },
});

export default AddToShelfView;
